import { LogsView } from "@/components/system-logs/LogsView";

export function LogsPage() {
  return (
    <div className="px-6 py-5">
      <div className="mb-5">
        <h1 className="font-display text-[20px] font-bold leading-tight">Logs</h1>
        <p className="text-[12px] text-muted-foreground">
          Server errors and API interactions — filter, search, and drill into any entry.
        </p>
      </div>

      <LogsView />
    </div>
  );
}
